import React from "react";
import { Collapse } from "react-bootstrap";
import countries from "../assets/countries";

function Step2Address({
  currentStep,
  handleGoToStep,
  handleNextStep,
  address,
  setAddress,
  validationErrors,
  setValidationErrors,
  validateAddress,
  fetchShippingRate,
  fetchClientSecret,
}) {
  return (
    <div className="card rounded-0 border-0 checkoutCard mb-3">
      <div className="card-header border-0 d-flex justify-content-between">
        <h5
          className={`text-capitalize mb-0 fw-bold ${
            currentStep === 2 ? "" : "text-grey"
          } ${currentStep > 2 ? "text-primary-color" : ""}`}
        >
          2. Address
        </h5>
        {currentStep > 2 ? (
          <button
            className="border-0 bg-0 text-grey"
            onClick={() => handleGoToStep(2)}
          >
            Edit
          </button>
        ) : null}
      </div>
      <Collapse in={currentStep === 2}>
        <div>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="name" className="text-capitalize form-label">
                Name
              </label>
              <input
                type="text"
                id="name"
                className={`form-control paymentInputFields ${
                  validationErrors.name ? "has-error" : ""
                }`}
                placeholder="Enter your name"
                value={address.name}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    name: e.target.value,
                  });
                  setValidationErrors({
                    ...validationErrors,
                    name: "",
                  });
                }}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="line1" className="text-capitalize form-label">
                Street Address
              </label>
              <input
                type="text"
                id="line1"
                className={`form-control paymentInputFields ${
                  validationErrors.line1 ? "has-error" : ""
                }`}
                placeholder="Enter your address"
                value={address.line1}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    line1: e.target.value,
                  });
                  setValidationErrors({
                    ...validationErrors,
                    line1: "",
                  });
                }}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="city" className="text-capitalize form-label">
                City
              </label>
              <input
                type="text"
                id="city"
                className={`form-control paymentInputFields ${
                  validationErrors.city ? "has-error" : ""
                }`}
                placeholder="Enter your city"
                value={address.city}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    city: e.target.value,
                  });
                  setValidationErrors({
                    ...validationErrors,
                    city: "",
                  });
                }}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="country" className="text-capitalize form-label">
                Country
              </label>
              <select
                id="country"
                className={`form-control paymentInputFields ${
                  validationErrors.country ? "has-error" : ""
                }`}
                value={address.country}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    country: e.target.value,
                  });
                  setValidationErrors({
                    ...validationErrors,
                    country: "",
                  });
                }}
              >
                <option value="">Select your country</option>
                {countries.map((country) => (
                  <option key={country.isoCode} value={country.isoCode}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label
                htmlFor="postal_code"
                className="text-capitalize form-label"
              >
                Postal Code
              </label>
              <input
                type="text"
                id="postal_code"
                className={`form-control paymentInputFields ${
                  validationErrors.postal_code ? "has-error" : ""
                }`}
                placeholder="Enter your postal code"
                value={address.postal_code}
                onChange={(e) => {
                  setAddress({
                    ...address,
                    postal_code: e.target.value,
                  });
                  setValidationErrors({
                    ...validationErrors,
                    postal_code: "",
                  });
                }}
              />
            </div>
            <div className="d-flex justify-content-between">
              <button
                className="continuePaymentBtn w-100 bg-primary-color border-0 p-1 text-white w-100"
                onClick={() => {
                  if (validateAddress()) {
                    fetchShippingRate();
                    handleNextStep(3);
                    fetchClientSecret();
                  }
                }}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default Step2Address;
